import React from 'react';
import ProjectTemplate from '../components/ProjectTemplate';

const BloomPage = () => {
  const media = [
    '/images/bloom_1.webp', 
    '/images/bloom_2.webp'
];

  return (
    <div className="bloom-page">
      
 <ProjectTemplate
title="bloom"
year="2018"
  sections={[
    {
      type: 'description',
      text: 
      <p>
      bloom is an generative program based on iterations of sets of shapes which have with carefully curated random boundaries.  Originally produced to accompany granular synthesis, this work rests confidently in being nothing more in essence than a sophisticated screen saver.  Due to its generative nature, no event will practically ever be the same.
      See a p5 version in realtime <a href="/"  rel="noopener noreferrer">here</a>. It was also used to produce the visuals for <a href="https://www.youtube.com/watch?v=ypVL8twuBdA"  rel="noopener noreferrer">TOOMBLAH - MIROBLOOM</a>
      </p> 
    },
    {
      type: 'video',
      links: ['https://www.youtube.com/embed/OA4UtneHCNg?si=htWBHwKvZW0FHHRs?controls=1&modestbranding=1&rel=0&showinfo=0']
    }, 
    {
      type: 'image',
      links: 
      [
        {
          src: media[0],
        }
      ], 
      isLink: false,
    },
    {
      type: 'image',
      links: 
      [
        {
          src: media[1],
        }
      ], 
      isLink: false,
    }
  ]}
  
/>

    </div>
  );
};

export default BloomPage;
